export const API_ENTRYPOINT = process.env.REACT_APP_API_ENTRYPOINT
